// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c365309f","339":"486665a5","401":"da724114","514":"9793d58c","548":"2bd90765","625":"344b9229","632":"8c63ce36","806":"284180c9","826":"f93b5997","980":"eb1a652d"}[chunkId] + ".chunk.css";
};